import {Component, OnDestroy, OnInit} from '@angular/core';
import {FilterStateService} from '../../dam-header/filter-state.service';
import {AssetStateService} from '../asset.state.service';
import { Subscription} from 'rxjs';
import {Asset} from '../asset.model';
import {AssetRenderStyle} from '../asset-render-style';
import {AssetResultComponent} from '../asset-result/asset-result.component';
import {AssetFilter} from '../asset-filter';
import {OrderBy} from '../order-by';
import {FormsModule} from '@angular/forms';
import {OrderDirection} from '../order-direction';
import {AssetCount} from '../asset-count';
import {NavStatusService} from '../../nav-status.service';
import {NavigationPoint} from '../../navigation-point';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {QueryParamsToFilterService} from '../../common/query-params-to-filter.service';

@Component({
  selector: 'app-asset-overview',
  imports: [
    AssetResultComponent,
    FormsModule,
  ],
  templateUrl: './asset-overview.component.html',
  styleUrl: './asset-overview.component.scss'
})
export class AssetOverviewComponent implements OnInit, OnDestroy {
  assetSubscription: Subscription | undefined | null;
  assetCount:AssetCount | undefined;
 // assets: Asset[] =  []
  assetFilter: AssetFilter | undefined;
  totalItems: number = 0;
  totalPages: number = 0;
  filterSubscription: Subscription | undefined;
  renderStyle = AssetRenderStyle.tile;
  pageInfoSubscription: Subscription | undefined;
  paramSubscription: Subscription | undefined;
  paramsHandled = false;

  constructor(private filterStateService: FilterStateService,
              private assetStateService: AssetStateService,
              private navStatusService: NavStatusService,
              private route: ActivatedRoute,
              private router: Router,
              private paramsToFilterService: QueryParamsToFilterService) {
  }

  get assets(): Asset[] {
    return this.assetStateService.loadedAssets;
  }

  ngOnInit() {
    this.paramSubscription = this.route.queryParams.subscribe(params => {
        // console.log('ASSETOverview: resetting collections now');
        this.assetStateService.collection$.next(null);
        this.assetStateService.readonlyCollection$.next(null);
        // console.log('parmas', params);
        if (this.isEmptyObject(params) && !this.paramsHandled) {
           // console.log('resetting state')
            this.assetStateService.resetState();
            this.assetStateService.filter = this.assetStateService.createDefaultAssetFilter();
        } else {
            if (!this.paramsHandled || params['assetId']) {
                if (!params['assetId']) {
                    // mediaId ist used to display single asset-detail
                    // other params are for filter creation
                    this.paramsToFilterService.parseQueryParams(params);
                    this.paramsHandled = true;
                    const queryParams = {};
                    this.router.navigate([], { queryParams, replaceUrl: true, relativeTo: this.route }).then();
                }
                if (params['assetId']) {
                    this.assetStateService.assetUuidFromQueryParam = params['assetId'];
                    this.assetStateService.resetState();
                    this.assetStateService.filter = this.assetStateService.createDefaultAssetFilter();
                    this.paramsHandled = true;
                }
            }

        }
     })
    this.navStatusService.setActiveNavPoint(NavigationPoint.assets);
    this.filterStateService.setShowFilterBar(true);
   // this.assetStateService.filter = this.assetStateService.createDefaultAssetFilter();
    this.filterSubscription = this.assetStateService.filter$.subscribe(result => {
        if (result) {
          this.assetFilter = result;
        }
      })
     this.pageInfoSubscription = this.assetStateService.pageInfo$.subscribe(result => {
         if (result) {
             this.totalItems = result.totalItems;
             this.totalPages = result.totalPages;
         }
     })


  }

  isEmptyObject(params: Params): boolean {
      for(var prop in params) {
          if(params.hasOwnProperty(prop))
              return false;
      }
      return true;
  }
  ngOnDestroy() {
   if(this.assetSubscription) {
      this.assetSubscription.unsubscribe();
    }
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
    if (this.pageInfoSubscription) {
        this.pageInfoSubscription.unsubscribe();
      }
    if (this.paramSubscription) {
        this.paramSubscription.unsubscribe()
    }
  }

  protected readonly OrderBy = OrderBy;
  protected readonly OrderDirection = OrderDirection;
  protected readonly AssetRenderStyle = AssetRenderStyle;
}
